const useFetch = () => {


    const generalFetch = async (path, body, url = process.env.REACT_APP_URL_DTO_KMI) => {
        try {
            let response = await fetch(url + path, body);
            let responseData = await response.json();
            if (("errorMessage" in responseData)) {
                throw new Error(typeof responseData.errorMessage === "string" ? responseData.errorMessage : JSON.stringify(responseData.errorMessage));
            }
            return { error: false, body: responseData, code: response.status };
        } catch (error) {
            if (error !== undefined) {
                // console.error(error.message)
                if (error.message !== undefined) {
                    if (error.message === "Failed to fetch") {
                        return { error: true, message: "Verifique que cuente con conexión a internet e inténtelo nuevamente. Si el problema persiste actualice la página." };
                    }
                    return { error: true, message: error.message };
                }
            }

            return { error: true, message: "Error desconocido." };
        }
    }

    return [generalFetch]
};

export default useFetch;